import type { ProviderOverview } from '@rp/contracts'
import { OPERATIONS_COPY } from './copy'

export type ProviderStatusLine = { text: string; danger: boolean }

export const providerStatusLine = (overview: ProviderOverview): ProviderStatusLine => {
  const classifier = overview.classifying
  const drafter = overview.answering
  if (classifier === null) {
    return drafter === null
      ? { text: OPERATIONS_COPY.nobodyAnswering, danger: true }
      : { text: OPERATIONS_COPY.answering(drafter), danger: false }
  }
  return drafter === null
    ? { text: OPERATIONS_COPY.draftingDown(classifier), danger: true }
    : { text: OPERATIONS_COPY.classifyingAndDrafting(classifier, drafter), danger: false }
}
